"use client";

import { motion } from "framer-motion";
import Eden from "../Eden/Eden";

type Props = {
  data: {
    edenContent: string;
    edenColor: string;
    edenIcon: string;
  };
};

const EdenRichText = (props: Props) => {
  const { data } = props;
  let color = data.edenColor ? data.edenColor : "default";
  return (
    <div className="max-w-[896px] py-4 sm:py-10 mx-auto">
      <div>
        <div className=" flex gap-2 mb-2 items-center">
          <div className="w-24 aspect-square">
            <Eden
              //   icon={data.edenIcon}
              className={`!gap-[0.2rem] ${
                color === "purple"
                  ? "!bg-[#7C44FF]"
                  : color === "green"
                  ? "!bg-[#31EB97]"
                  : ""
              }`}
              iconSize={48}
            />
          </div>
          <p className="text-black p-4 block rounded-lg bg-white/50 sm:bg-transparent sm:text-white/50 ">
            Eden
          </p>
        </div>
        <div className="flex max-w-[1008px]">
          <div className="hidden sm:block sm:min-w-[97px]  aspect-square"></div>
          <div className="word-content text-[26px] sm:text-[36px] md:text-h4 rounded-tl-none py-4 px-6 rounded-3xl bg-white inline-block font-semibold text-main-dark-green leading-tight">
            <motion.div>
              {data.edenContent}
              {/* <Word text={data.content} /> */}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EdenRichText;
